<template>
  <div class="animated fadeIn">
    <b-card>
      <b-card-header>
        <i class="icon-menu mr-1"></i>選單列表
        <div class="card-header-actions">
          <b-link @click="openEditor()"><i class="fa fa-plus"></i> 新增</b-link>
        </div>
      </b-card-header>
      <b-card-body>
      <v-server-table :columns="columns" :data="data" :options="options" :theme="theme" ref="dataTable" id="dataTable">
        <a slot="user_id" slot-scope="props">{{props.row.Admin.firstname + ' ' + props.row.Admin.lastname}}</a>
        <a slot="icon" slot-scope="props"><i :class="props.row.icon" class="text-center w-100 d-block"></i></a>
        <a slot="is_admin" slot-scope="props" class="text-center w-100 d-block"><span :class="props.row.is_admin?'text-info':'text-warning'">{{props.row.is_admin ? '是': '否'}}</span></a>

        <div slot="child_row" slot-scope="props">
          <b-button variant="info" class="btn-pill" size="sm" @click="editRow(props.row.id, props.row)"><i class="fa fa-pencil"></i> 編輯</b-button> &nbsp;
          <b-button variant="danger" class="btn-pill" size="sm" @click="delRow(props.row.id, props.row.name)"><i class="fa fa-times"></i> 刪除</b-button> &nbsp;
        </div>
      </v-server-table>
      </b-card-body>
    </b-card>

    <b-modal title="刪除選單" size="sm" v-model="delRowShowModal" @ok="submitDelRow(delRowId)" ok-title="確定" cancel-title="取消">
        {{delRowMsg}}
    </b-modal>

    <b-modal title="編輯器" size="lg" class="modal-info" v-model="showEditorModal" @ok="submitRecord" ok-title="儲存" cancel-title="取消" :ok-disabled="$v.$invalid">
        <b-form>
            <h1>選單項目資料</h1>
            <p class="text-muted">綠框為必填</p>
            
            <b-input-group class="mb-3">
              <b-input-group-prepend>
                <b-input-group-text><i class="fa fa-clone"></i></b-input-group-text>
              </b-input-group-prepend>
              <b-form-input type="text" 
                            class="form-control" 
                            placeholder="名稱" 
                            v-model.lazy.trim="$v.record.name.$model"
                            v-focus
                            :state="chkState('name')"
                            aria-describedby="invalidNameFeedback"/>
              <b-form-invalid-feedback id="invalidNameFeedback">名稱必填</b-form-invalid-feedback>
            </b-input-group>

            <b-input-group class="mb-3">
              <b-input-group-prepend>
                <b-input-group-text><i class="fa fa-link"></i></b-input-group-text>
              </b-input-group-prepend>
              <b-form-input type="text" 
                            class="form-control" 
                            placeholder="URL" 
                            v-model.lazy.trim="$v.record.url.$model"
                            :state="chkState('url')"
                            aria-describedby="invalidUrlFeedback"/>
              <b-form-invalid-feedback id="invalidUrlFeedback">URL必填</b-form-invalid-feedback>
            </b-input-group>

            <b-input-group class="mb-4">
              <b-input-group-prepend>
                <b-input-group-text><i class="fa fa-user-secret"></i></b-input-group-text>
              </b-input-group-prepend>
              <b-form-select v-model="record.is_admin" :options="is_admin_options" placeholder="管理員專用?"></b-form-select>
            </b-input-group>

            <b-input-group class="mb-4">
              <b-input-group-prepend>
                <b-input-group-text><i class="fa fa-font"></i></b-input-group-text>
              </b-input-group-prepend>
              <b-form-input type="text" 
                            class="form-control" 
                            placeholder="ICON" 
                            v-model.lazy.trim="record.icon"/>
            </b-input-group>

        </b-form>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import {ServerTable, Event} from 'vue-tables-2'
import { required, minLength, between, email, minValue, integer } from 'vuelidate/lib/validators'
import Multiselect from 'vue-multiselect'
import config from '@/config/global'
import notifications from '@/config/notifications'
import jQuery from 'jquery'
import select2 from 'select2'
import vSelect from 'vue-select'
import qrcode from 'qrcode'
import sha1 from 'sha1'
import _ from 'lodash'

const encrypt    = config.encrypt;
const decrypt    = config.decrypt;
const admin_root = config.admin_root;

const clean_form = {
  name:     '',
  url:      '',
  icon:     '',
  is_admin: false,
  unit_id:  ''
};

let $selec2 = null;

Vue.use(ServerTable)

export default {
  name: 'device_list',
  notifications,
  components: {
    ServerTable,
    Event,
    Multiselect,
    vSelect
  },
  data(){
    let app = this;
    return {
      device_uri: '',
      showQrCode: false,
      showRoleModal: false,
      selected_row: null,
      isFindingLoading: false,
      editRowId: null,
      record: Object.assign({}, clean_form),
      showEditorModal: false,
      delRowShowModal: false,
      delRowId: 0,
      delRowMsg: '',
      columns: ['name', 'url', 'icon', 'is_admin','user_id','created'],
      data: [],
      is_admin_options: [
        {value:false, text:'否'},
        {value:true, text:'是'}
      ],
      options: {
        headings: {
          name:  '名稱',
          url:    'URL',
          icon: 'ICON',
          is_admin: '管理員專用？',
          user_id: '建立人',
          created: '建立時間'
        },
        orderBy: {
          column: 'created',
          ascending: false
        },
        sortable: ['name', 'url', 'icon', 'is_admin', 'user_id', 'created'],
        filterable: ['name', 'url'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        pagination: {
          chunk: 5,
          edge: false,
          nav: 'scroll'
        },
        perPage: 25,
        requestFunction(data) {
          let action = `${admin_root}/get_list/Nav`;
          let params = {
              keyset: 'mqtt'
          };

          for(let col in data){
            params[col] = data[col];
          }

          return fetch(action, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
            },
            body: JSON.stringify(params)
          }).then(res => res.json()).then(result => {
            return {
              data: result.data || [],
              count: result.count || 0
            };
          }).catch(error => {
            return {
              data: [],
              count: 0
            };
          });
        }//eo requestFunction
      },
      useVuex: false,
          theme: 'bootstrap4',
          template: 'default'
    };//eo return
  },//eo data

  methods: {

    editRow(row_id, row) {
      // console.info('edit row_id:', row_id);
      this.selected_row = row;
      this.openEditor(row_id);

      this.selected_row['serialno'] = row['sn'];

      if(this.selected_row['end_user_id'] == 0){
        this.selected_row['end_user_id'] = '';
      }

      this.record = Object.assign({}, this.selected_row);
    },//eo editRow

    delRow(row_id, row_name) {
      // console.info('del row_id:', row_id);

      this.delRowShowModal = row_id ? true : false;
      this.delRowId        = row_id;
      this.delRowMsg       = `您確定要刪除${row_name}嗎？`;
    },//eo delRow

    submitDelRow(row_id) {
      
      let app    = this;
      let action = `${admin_root}/update_navigation`;
      let params = {
          keyset: 'mqtt',
          record: encodeURIComponent(encrypt(JSON.stringify({
            id: row_id,
            field: 'valid',
            value: 0,
            value_type: 'int'
          })))
      };

      fetch(action, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' +  app.$state.$get('adminuser').token
        },
        body: JSON.stringify(params)
      }).then(res => res.json()).then(result => {
        if(result.success){
          app.showSuccess({
            title: '資料更新成功',
            message: result.message
          });

          app.$refs['dataTable'].refresh();
        } else {
          app.showError({
            title: '資料更新失敗',
            message: result.message
          });
        }
      }).catch(error => {
        app.showError({
          title: '資料更新失敗',
          message: error
        });
      });
    },

    testRow(row_id) {
      console.info('test row_id:', row_id);
      this.showWarn({
        message: '開發中',
        title: '功能暫停'
      });
    },//eo testRow

    chkState(val) {
      const field = this.$v.record[val];
      return !field.$dirty || !field.$invalid;
    },

    openEditor(row_id){
      this.editRowId       = row_id;
      this.showEditorModal = true;
      this.$v.$reset();

      let page_limit = 10;
      let app        = this;

      //workaround for select2 to be able to use search input
      jQuery('div.modal-content').removeAttr('tabindex');

      console.info('app.selected_row:', app.selected_row);

      if(row_id && app.selected_row){
        //do nothing for now
      } else {
        app.record       = Object.assign({}, clean_form);
        app.selected_row = null;
        app.row_id       = null;
      }
    },

    submitRecord() {

      let app    = this;
      let row_id = app.editRowId;

      this.$v.$touch();

      if (this.$v.$invalid) {
          this.showError({message:'請輸入必填欄位', title:'資料錯誤'});
          return false;
      }

      let to_save = this.record;

      if(row_id){
        to_save['id'] = row_id;
      }

      to_save = encodeURIComponent(encrypt(JSON.stringify(to_save)));

      let action = `${admin_root}/save_navigation`;
      let params = {
        keyset: 'mqtt',
        record: to_save
      };

      fetch(action, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.$state.$get('adminuser').token
        },
        body: JSON.stringify(params)
      }).then(res => res.json()).then(result => {
        if(result.success){
          app.showSuccess({
            title: '成功',
            message: '資料成功儲存'
          });
          app.$refs['dataTable'].refresh();
          app.record = Object.assign({}, clean_form);
          app.$v.$reset();
        } else {
          app.showError({
            title: '錯誤',
            message: '無法儲存資料，請稍後再試'
          });
          app.$refs['dataTable'].refresh();
        }
      }).catch(error => {
        app.showError({
          title: '錯誤',
          message: '無法儲存資料，請稍後再試'
        });
        app.$refs['dataTable'].refresh();
      });
    },

    genRow(row_id) {
      // console.info('row clicked: ', row_id);
      this.showQrCode = true;
      row_id          = encodeURIComponent(config.encrypt(row_id, config.ffkey, config.ffiv));

      let msg = `${config.frontend}?uuid=${row_id}`;
      qrcode.toCanvas(document.getElementById('qrcode-canvas'), msg);
      this.device_uri = msg;
    },//eo onRowClick

    showRoles(nav_id) {

    },
  },//eo methods

  validations: {
    record: {
      name: {
        required,
        minLength: minLength(2)
      },
      url: {
        required,
        minLength: minLength(8),
      },
    }
  },//eo validations
  
};
</script>
<style lang="scss">
.card-body{padding:0;}
.add-btn{}
.multiselect__input{width:100%;border:none;}
#qrcode-canvas{
  display:inline-block;
  margin: auto;
}
#dataTable {
  width: 95%;
  margin: 0 auto;
  margin-top: 0.5rem;
  font-size: 0.75rem;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .vue-title {
    text-align: center ;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.25rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }

  .VueTables__sortable {
    padding: 0.25rem;
  }
}
</style>
